/** Reports ▸ Projects (#1388 slice 84). The six native keys, in family order. */

export const PROJECT_REPORTS = [
  ['project_portfolio', 'Portfolio'],
  ['project_ageing', 'Ageing'],
  ['project_forecast', 'Forecast to close'],
  ['project_hardware', 'Hardware and PO status'],
  ['project_margin', 'Project margin'],
  ['project_workload', 'PM workload'],
] as const

export type ProjectReportKey = (typeof PROJECT_REPORTS)[number][0]

const KEYS = new Set<string>(PROJECT_REPORTS.map(([key]) => key))

export function isProjectReport(key: string): key is ProjectReportKey {
  return KEYS.has(key)
}

export const PLATFORMS: { value: string; label: string }[] = [
  { value: 'avaya', label: 'Avaya' },
  { value: 'smartpbx', label: 'SmartPBX' },
  { value: 'mitel', label: 'Mitel' },
  { value: 'network', label: 'Network' },
  { value: 'legacy', label: 'Legacy' },
  { value: 'btc_integration', label: 'BTC' },
  { value: 'microsoft', label: 'Microsoft' },
  { value: 'other', label: 'Other' },
]

export const PROJECT_STATES: { value: string; label: string }[] = [
  { value: 'intake', label: 'Intake' },
  { value: 'planning', label: 'Planning' },
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'closeout', label: 'Closeout' },
  { value: 'on_hold', label: 'On hold' },
  { value: 'closed', label: 'Closed' },
  { value: 'cancelled', label: 'Cancelled' },
]

export function stateLabel(state: string): string {
  return PROJECT_STATES.find((item) => item.value === state)?.label ?? state
}
